module.exports = __webpack_public_path__ + "static/media/Plan&Billing.927bdab2.svg";